import { TileSizes } from '@ad-lucy/components/layout/Grid/TileSizeContext';
import type { GridInterface } from '@ad-lucy/context/adData/contentData/types';
import { BREAKPOINT_DISPLAY_NAME, BREAKPOINT_VALUE } from '@ad-lucy/grid-breakpoints';

import { defineGrid } from './defineGrid';

export const grid1x2x0 = (): GridInterface[] =>
  defineGrid('1:2:0', [
    {
      name: BREAKPOINT_DISPLAY_NAME.SITEBAR,
      breakpoint: BREAKPOINT_VALUE.SITEBAR,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanCol: 2,
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              spanRow: 2,
            },
            {
              tileId: 2,
              spanRow: 2,
            },
          ],
        },
      ],
    },
    {
      name: 'HPA 1/2',
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              spanRow: 2,
            },
          ],
        },
      ],
    },
    {
      name: 'HPA 2/2',
      breakpoint: BREAKPOINT_VALUE.HPA,
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              spanRow: 2,
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 1/2 (1:1:0)',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      groupId: '1:1',
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 1,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 2/2 (1:1:0)',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      groupId: '1:1',
      rows: [
        {
          columns: [
            {
              tileId: 0,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
        {
          columns: [
            {
              tileId: 2,
              tileSize: TileSizes['400x400'],
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 1/3 (2:3)',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      groupId: '2:3',
      rows: [
        {
          columns: [
            {
              tileId: 0,
              spanRow: 2,
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 2/3 (2:3)',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      groupId: '2:3',
      rows: [
        {
          columns: [
            {
              tileId: 1,
              spanRow: 2,
            },
          ],
        },
      ],
    },
    {
      name: 'Mobile 3/3 (2:3)',
      breakpoint: BREAKPOINT_VALUE.MOBILE,
      groupId: '2:3',
      rows: [
        {
          columns: [
            {
              tileId: 2,
              spanRow: 2,
            },
          ],
        },
      ],
    },
  ]);
